import { render, staticRenderFns } from "./chartDoughnut.vue?vue&type=template&id=152b139e&scoped=true&"
import script from "./chartDoughnut.vue?vue&type=script&lang=js&"
export * from "./chartDoughnut.vue?vue&type=script&lang=js&"
import style0 from "./chartDoughnut.vue?vue&type=style&index=0&id=152b139e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b139e",
  null
  
)

export default component.exports